import { useState, useCallback, useEffect } from 'react';

/**
 * A useState-compatible hook that persists state to localStorage.
 * Falls back to in-memory state if localStorage is unavailable.
 */
export function useLocalStorage<T>(key: string, defaultValue: T): [T, React.Dispatch<React.SetStateAction<T>>] {
    const [value, setValue] = useState<T>(() => {
        try {
            const stored = localStorage.getItem(key);
            return stored !== null ? JSON.parse(stored) : defaultValue;
        } catch {
            return defaultValue;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch {
            // localStorage full or unavailable — silent fail
        }
    }, [key, value]);

    return [value, setValue];
}
